<div mat-dialog-title>Create Offering</div>

<form [formGroup]="form">
<mat-dialog-content class="fx-col fx-gap-20">

  <div class="heading-bold">Offering Details</div>

  <div class="fx-row full-width fx-gap-10">
    <mat-form-field class="fx-flex-1">
      <mat-label>Offering Name</mat-label>
      <input matInput [formControl]="form.controls.name" placeholder="e.g. Cape Town District" />
      <mat-error>Offering name is required</mat-error>
    </mat-form-field>

    <mat-form-field class="fx-flex-1">
      <mat-label>Offering Code</mat-label>
      <input matInput [formControl]="form.controls.code" placeholder="e.g. CPT-D1" />
      <button mat-icon-button matSuffix type="button"
              matTooltip="Auto-generate code from the offering name"
              aria-label="Generate code from name"
              (click)="generateCode()">
        <mat-icon>auto_fix_normal</mat-icon>
      </button>
      <mat-error>Offering code is required</mat-error>
    </mat-form-field>
  </div>

  <mat-form-field class="full-width">
    <mat-label>Type</mat-label>
    <mat-select [formControl]="form.controls.type">
      @for (opt of typeOptions; track opt.code) {
        <mat-option [value]="opt.code">{{ opt.label }}</mat-option>
      }
    </mat-select>
    <mat-error>Type is required</mat-error>
  </mat-form-field>

  <div class="fx-row full-width fx-gap-10">
    <mat-form-field class="fx-flex-1">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" [formControl]="form.controls.startDate" placeholder="select" />
      <mat-datepicker-toggle [for]="startPicker" matIconSuffix>
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error>Start date is required</mat-error>
    </mat-form-field>

    <mat-form-field class="fx-flex-1">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [formControl]="form.controls.endDate" placeholder="select" />
      <mat-datepicker-toggle [for]="endPicker" matIconSuffix>
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <mat-form-field class="full-width">
    <mat-label>Address</mat-label>
    <input
      matInput
      matGoogleMapsAutocomplete
      [formControl]="form.controls.address"
      placeholder="Start typing an address..."
      (onAutocompleteSelected)="onAutocompleteSelected($event)"
      (onLocationSelected)="onLocationSelected($event)"
    />
    <mat-error>Address is required</mat-error>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Description</mat-label>
    <textarea matInput [formControl]="form.controls.description" rows="3"></textarea>
  </mat-form-field>

  <div class="heading-bold">Images <span style="color: var(--mat-sys-on-surface-variant); font-size: 0.85em; font-weight: normal;">(optional — can be added later in Offering Settings)</span></div>

  <div class="fx-row full-width fx-gap-10">
    <div class="fx-col fx-flex-1 fx-gap-10">
      <span>Tile Image</span>
      <div class="fx-row fx-v-center fx-gap-10">
        <button mat-stroked-button type="button" (click)="tileFileInput.click()">
          <mat-icon>upload</mat-icon> Choose File
        </button>
        @if (tileImageFile) {
          <span>{{ tileImageFile.name }}</span>
          <button mat-icon-button type="button" aria-label="Remove tile image" (click)="clearTileImage()">
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <span style="color: var(--mat-sys-on-surface-variant);">No file chosen</span>
        }
      </div>
      <input #tileFileInput type="file" accept="image/*" hidden (change)="onTileImageSelected($event)" />
    </div>

    <div class="fx-col fx-flex-1 fx-gap-10">
      <span>Banner Image</span>
      <div class="fx-row fx-v-center fx-gap-10">
        <button mat-stroked-button type="button" (click)="bannerFileInput.click()">
          <mat-icon>upload</mat-icon> Choose File
        </button>
        @if (bannerImageFile) {
          <span>{{ bannerImageFile.name }}</span>
          <button mat-icon-button type="button" aria-label="Remove banner image" (click)="clearBannerImage()">
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <span style="color: var(--mat-sys-on-surface-variant);">No file chosen</span>
        }
      </div>
      <input #bannerFileInput type="file" accept="image/*" hidden (change)="onBannerImageSelected($event)" />
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loader.loading$ | async">Cancel</button>
  <button mat-flat-button class="button-primary" (click)="onSubmit()" [disabled]="loader.loading$ | async">
    Create Offering
  </button>
</mat-dialog-actions>
</form>
